import styles from './styles.less';


const WatchASLogo = (props) => (
    <div className={ cx(styles.root, props.className) }>
        { !props.logoOnly && !!props.authenticated &&
        <svg
            className={ styles.check }
            enableBackground='new 0 0 10.083 10.068'
            viewBox='0 0 10.083 10.068'
            x='0'
            xmlSpace='preserve'
            y='0'>
            <path d='M5.042,0C2.257,0,0,2.257,0,5.042c0,2.784,2.257,5.042,5.042,5.042s5.042-2.257,5.042-5.042 C10.083,2.257,7.826,0,5.042,0z M4.07,7.471L1.939,5.305l0.74-0.751L4.102,6l3.334-3.386l0.709,0.72L4.07,7.471z'></path>
        </svg> }
        { !props.logoOnly && !props.authenticated &&
        <svg
            className={ styles.key }
            enableBackground='new 0 0 16.529 8.484'
            viewBox='0 0 16.529 8.484'
            x='0px'
            xmlSpace='preserve'
            y='0px'>
            <path d='M15.515,2.656H8.187c0,0,0-0.002-0.001-0.004c-0.005-0.02-0.08-0.231-0.16-0.35 C7.699,1.809,7.327,1.27,6.827,0.888C6.712,0.8,6.593,0.723,6.475,0.646C4.652-0.471,2.243-0.05,0.919,1.689 c-1.412,1.853-1.052,4.496,0.804,5.907c1.851,1.412,4.495,1.052,5.903-0.8c0.018-0.02,0.032-0.041,0.048-0.062 c0.103-0.141,0.196-0.287,0.281-0.436C7.965,6.275,7.977,6.254,7.99,6.233c0.013-0.026,0.03-0.052,0.039-0.073 c0.023-0.057,0.04-0.099,0.054-0.132c0.002-0.005,0.005-0.011,0.006-0.015c0.01-0.025,0.017-0.04,0.022-0.055h1.078L9.54,4.936 h0.807l0.381,1.022h0.747l0.364-1.022h0.743l0.294,1.022h0.695l0.403-1.022h1.537l0.962-0.966L15.515,2.656z M3.332,4.913 c-0.357,0.47-1.03,0.563-1.5,0.206C1.364,4.76,1.271,4.088,1.63,3.618C1.986,3.149,2.66,3.056,3.13,3.414 C3.6,3.772,3.69,4.447,3.332,4.913z'></path>
        </svg> }
        <svg
            className={ styles.logo }
            enableBackground='new 0 0 112.865 24.485'
            viewBox='0 0 112.865 24.485'
            x='0'
            xmlSpace='preserve'
            y='0'>
            <g>
                <path d='M85.652,15.064c0-0.818,0.22-1.282,0.683-1.636c0.411-0.327,1.011-0.356,2.402-1.09c0,0.599-0.027,1.364-0.027,2.589c0,1.474-0.846,2.02-1.774,2.02C86.118,16.947,85.652,16.237,85.652,15.064z M85.734,9.393c0.028-1.281,0.384-2.016,1.611-2.016c0.982,0,1.391,0.572,1.391,1.471c0,1.118-0.245,1.337-1.583,1.692c-1.229,0.326-2.867,0.599-3.959,1.199c-1.092,0.6-1.802,2.045-1.802,3.762c0,3.191,1.447,4.499,3.932,4.499c1.473,0,2.866-0.763,3.466-2.071h0.055c0.027,0.573,0.083,1.171,0.245,1.691h4.259c-0.518-0.656-0.518-2.072-0.518-3.191v-7.58c0-3.108-1.611-4.362-5.243-4.362c-1.829,0-3.085,0.246-4.124,0.954c-1.036,0.709-1.637,1.936-1.665,3.953H85.734z'></path>
                <path d='M98.61,14.927c0.028,0.656,0.083,1.227,0.299,1.663c0.248,0.409,0.658,0.682,1.367,0.682c1.037,0,1.583-0.655,1.583-1.5c0-0.681-0.328-1.335-1.693-1.798c-3.63-1.227-5.38-1.936-5.38-5.044c0-2.945,2.076-4.444,5.626-4.444c4.149,0,5.35,2.017,5.35,4.144V9.12h-3.931V8.847c0-1.282-0.518-1.635-1.445-1.635c-1.175,0-1.503,0.572-1.503,1.364c0,2.616,7.073,0.871,7.073,6.597c0,2.971-1.995,4.825-5.652,4.825c-3.96,0-5.627-1.472-5.627-4.416v-0.656H98.61z'></path>
                <path d='M74.205,0.001h6.908v3.054h-2.812V21.43h2.812v3.054h-6.908V0.001z'></path>
                <path d='M105.957,21.43h2.813V3.053h-2.813V0h6.908v24.485h-6.908V21.43z'></path>
            </g>
            <g>
                <path d='M0,4.758h4.426l1.419,10.883h0.056L7.567,4.758h4.753l1.557,10.883h0.054l1.557-10.883h4.261l-3.196,14.756h-4.997L9.943,8.631H9.889L8.167,19.513h-5.08L0,4.758z'></path>
                <path d='M20.43,9.286c0.028-2.019,0.629-3.246,1.667-3.954c1.037-0.709,2.294-0.954,4.124-0.954c3.632,0,5.245,1.254,5.245,4.364v7.581c0,1.118,0,2.536,0.518,3.191h-4.261c-0.163-0.518-0.218-1.119-0.244-1.691h-0.055c-0.602,1.308-1.995,2.072-3.47,2.072c-2.485,0-3.934-1.308-3.934-4.501c0-1.717,0.71-3.163,1.803-3.762c1.094-0.6,2.732-0.873,3.961-1.199c1.338-0.356,1.584-0.573,1.584-1.691c0-0.901-0.41-1.474-1.393-1.474c-1.229,0-1.585,0.737-1.612,2.019H20.43z M25.565,16.841c0.929,0,1.774-0.546,1.774-2.019c0-1.226,0.029-1.989,0.029-2.591c-1.393,0.738-1.994,0.764-2.403,1.093c-0.465,0.353-0.683,0.817-0.683,1.637C24.282,16.131,24.746,16.841,25.565,16.841z'></path>
                <path d='M34.741,7.813h-1.83V4.758h1.83V0.422h4.425v4.336h2.049v3.055h-2.049v7.446c0,1.035,0.382,1.363,1.42,1.363c0.191,0,0.438-0.028,0.629-0.054v2.946c-0.847,0.109-1.694,0.163-2.54,0.163c-3.06,0-3.934-0.545-3.934-3.981V7.813z'></path>
                <path d='M50.037,10.322c0-2.154-0.491-3.055-1.666-3.055c-1.475,0-1.666,1.855-1.666,4.883c0,3.326,0.191,4.855,1.666,4.855c1.31,0,1.61-0.899,1.666-3.492h4.097c-0.026,4.555-1.83,6.382-5.844,6.382c-5.572,0-6.01-3.9-6.01-8.291c0-4.145,1.202-7.226,6.01-7.226c4.643,0,5.844,2.425,5.844,5.945H50.037z'></path>
                <path d='M55.361,0.041h4.426v6.328h0.055c0.711-1.447,1.885-1.992,3.387-1.992c2.512,0,3.852,1.254,3.852,4.092v11.045h-4.425V9.45c0-1.064-0.466-1.691-1.285-1.691c-0.846,0-1.583,0.654-1.583,2.1v9.654h-4.426V0.041z'></path>
            </g>
        </svg>
    </div>
);

WatchASLogo.propTypes = {
    authenticated: React.PropTypes.bool,
    logoOnly: React.PropTypes.bool
};

WatchASLogo.defaultProps = {
    authenticated: false,
    logoOnly: false
};


export default WatchASLogo;



// WEBPACK FOOTER //
// ./src/common/components/watch-as-logo/index.js